module.exports = __webpack_public_path__ + "static/media/2-FuentesVargas.851d930f.png";